import {
  DOCUMENT_UPLOAD_TYPE,
  type TransactionDocument,
  type UploadTransactionDocumentPayload,
} from '@/types/transaction-document';

/**
 * Demo-mode fabricated response for uploading a transaction document.
 * Used as the demoFn for useUploadTransactionDocument.
 */
export function uploadTransactionDocumentDemoResponse({
  file,
  transactionReference,
}: UploadTransactionDocumentPayload): TransactionDocument {
  return {
    id: `tdoc-demo-${Date.now()}`,
    fileName: file.name,
    fileType: file.type,
    fileSize: file.size,
    documentType: DOCUMENT_UPLOAD_TYPE,
    uploadedAt: new Date().toISOString(),
    uploadedByEmail: 'demo@example.com',
    transactionReference,
  };
}
